import {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {SelectField} from "@/components/form/fields/SelectField/SelectField.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";
import {IntegrationModuleInfo, IntegrationModules} from "@/pages/integrations/integrations.types.ts";

export type FormValuesKey = keyof IntegrationFormData;

interface PushoverFormProps {
  serverErrors?: ServerErrors;
}

export const PushoverForm = ({serverErrors}: PushoverFormProps) => {
  const {setError} = useFormContext();

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((k) => k !== "__all__")
        .forEach((key) => setError(`settings.${key}` as FormValuesKey, {message: serverErrors[key][0]}));
    }
  }, [setError, serverErrors]);

  return (
    <div>
      <div className="row row-cols-2 mb-3">
        <div className="col-6 mb-3">
          <InputField
            name="settings.user"
            label="Recipient Key"
            required={true}
            tooltip="This may be your user key or a group key."
            autoFocus={true}
          />
        </div>
        <div className="col-6 mb-3">
          <SelectField
            name="settings.priority"
            label="Notification priority"
            required={true}
            options={[
              {value: "-2", label: "Lowest"},
              {value: "-1", label: "Low"},
              {value: "0", label: "Normal"},
              {value: "1", label: "High"},
              {value: "2", label: "Emergency"},
            ]}
            tooltip="Priorities higher then normal will override recipient's quiet hours."
          />
        </div>
      </div>
      <SetupInfo>
        <div className="p-2">
          In your Pushover homepage, copy the code under "Your User Key" into the "Recipient key" box above, then select
          your desired priority. For advanced usage, you may use a Pushover group key instead.
        </div>
        <div className="p-2">
          <a target="_blank" href="https://support.uptime.com/hc/en-us/articles/115002536389-Configuring-Pushover">
            View {IntegrationModuleInfo[IntegrationModules.PUSHOVER].label} Support Article &rarr;
          </a>
        </div>
      </SetupInfo>
    </div>
  );
};
